/** Capability URLs grant access through their path: every telemetry channel redacts them. */
export const HIVE_CAPABILITY_PATH_PREFIXES = [
    '/claim',
    '/consent/minor',
    '/invoices',
    '/proposals',
    '/preferences',
    '/v3/public/license-gifts',
    '/v3/public/minor-consent',
    '/v3/public/invoices',
    '/v3/public/proposals',
    '/v3/public/hives',
];
export const CHECKOUT_CAPABILITY_PATH_PREFIXES = ['/proposal'];
/** A referrer can come from any first-party surface, regardless of its destination host. */
export const CAPABILITY_PATH_PREFIXES = [
    ...HIVE_CAPABILITY_PATH_PREFIXES,
    ...CHECKOUT_CAPABILITY_PATH_PREFIXES,
];
